import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng';
import { ConfirmationService, SelectItem } from 'primeng';
import { OrganisationSpecificStepsService } from '../../../services/organisation-specific-steps.service';

import { CustomerService } from '../../../services/customer.service';
import { OrganisationsService } from '../../../services/organisations.service';
import { TaskTypeService } from '../../../services/task-type.service';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'org-specific-steps-admin',
  templateUrl: './organisations-specific-steps-admin.component.html',
  styleUrls: ['./organisations-specific-steps-admin.component.scss'],
})
export class OrganisationSpecificStepsAdminComponent implements OnInit {
  checklists: any;
  customers: any;
  assignedCustomers: any;
  unAssignedCustomers: any;

  constructor(
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private orgService: OrganisationsService,
    private router: Router,
    private taskTypeService: TaskTypeService,
    private organisationsService: OrganisationsService,
    public messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    private organisationSpecificStepService: OrganisationSpecificStepsService,
    private loggerService: LoggerService,
  ) {}

  ngOnInit() {}
}
